<button nz-button nzSize="large" [nzBlock]="fullSize" (click)="resetLot()">
  <i nz-icon nzType="retweet" nzTheme="outline"></i>
  <span *ngIf="fullSize">
    {{ 'RESET_LOT.TITLE' | translate }}
  </span>
</button>
